import { useTranslation } from "react-i18next";
import "./daprefactor.scss";
import DALayout from "../da-layout";
import { Breadcrumb, Button, Col, Form, Input, Image, Row, Steps, message } from "antd";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { complexDigitToman, isEmptyObject, validateInput } from "../../../../tools/tools";
import { useEffect, useState } from "react";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { useDispatch, useSelector } from "react-redux";

const DaPrefactor = () => {
  const [t] = useTranslation("global");
  const [messageApi, contextHolder] = message.useMessage();
  const { queryTaxPercent } = useAPIPublic();
  const { sWPreFactor, calculateSWCommissionPrice } = useDealer();

  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });

  const nav = useNavigate();
  const location = useLocation();
  const [frmKit] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [priceSw, setPriceSw] = useState(0);
  const [tax, setTax] = useState(0);
  const [iccCommission, setIccCommission] = useState(0);
  const [commission, setCommission] = useState(0);
  const [purchaseID, setPurchaseID] = useState(0);

  useEffect(() => {
    const CallInitial = async () => {
      try {
        //call CalC Price SW
        let payload = {
          msisdn: location?.state?.daChange.aptelMSIDSN,
          certno: location?.state?.purchase?.stR_CertNo,
        };
        let response = await sWPreFactor(payload);
        if (response) {
          setPriceSw(response.productPrice);
          setPurchaseID(response.spPurchaseId);
          let payCommission = {
            msisdn: location?.state?.daChange.aptelMSIDSN,
            productid: response?.productid,
            iccid: location?.state?.kitNo,
            planid: process.env.REACT_APP_PLANID_DELIVERY_AREA
          };
          let resCommission = await calculateSWCommissionPrice(payCommission);
          if (resCommission) {
            setIccCommission(resCommission?.iccidCommission);
            setCommission(resCommission?.commission);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (location?.state) {
      CallInitial();
    }
  }, [location?.state]);

  const handleSubmit = async () => {
    if (purchaseID) {
      nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Document, {
        state: { daChange: location?.state?.daChange, purchase: location?.state?.purchase, kitNo: location?.state?.kitNo },
      });
    } else {
      messageApi.open({
        type: "error",
        content: "سریال خرید سیم کارت وجود ندارد",
      });
    }

    // if (wallet - (taxPrice + priceSw) >= 0) {

    // } else {
    //   messageApi.open({
    //     type: "error",
    //     content: "موجودی کیف پول کافی نمی باشد.",
    //   });
    // }
  };

  return (
    <>
      <DALayout>
        {contextHolder}
        <div className="container-main container-da">
          <div className="g-hold-title-of-page">
            <Breadcrumb
              className="breadcrumbs"
              items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("deliveryArea.title") }]}
            />
            <div className="title-page">
              <h3>{t("deliveryArea.title")}</h3>
              <p></p>
            </div>
          </div>
          <div className="g-layout-content">
            <Content className="g-layout-main da-container">
              <div className="g-format-page">
                <div className="g-body-format-page">
                  <div className="g-format-steps">
                    <div className="holder-step">
                      <Steps
                        size="small"
                        className="step-wizard"
                        current={2}
                        responsive
                        items={[
                          {
                            title: "احراز هویت",
                          },
                          {
                            title: "شماره کیت جدید",
                          },
                          {
                            title: "سند",
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="cs-prefactor-container">
                    <div className="g-prefactor">
                      <div className="holder-row-prefactor">
                        <Row gutter={16}>
                          <Col span={14} xl={14} lg={14} md={24} sm={24} xs={24}>
                            <div className="for-pay-client">
                              <h3>صورت حساب مشتری</h3>
                              <div className="holder-box">
                                <div className="holder-profile">
                                  <h4>
                                    مشخصات سیم کارت{" "}
                                    <Link
                                      to={
                                        _adr.Root +
                                        _adr.SimCardReplacement.Index +
                                        _adr.SimCardReplacement.Replacement +
                                        _adr.SimCardReplacement.ValidKit
                                      }
                                      state={{
                                        msisdn: location?.state?.daChange.aptelMSIDSN,
                                        certno: location?.state?.purchase?.stR_CertNo,
                                      }}
                                    >
                                      <i className="icon-edit"></i>
                                    </Link>
                                  </h4>
                                  <div className="list-item">
                                    <div className="item">
                                      <div className="label">شماره موبایل:</div>
                                      <div className="value">
                                        <span dir="ltr">{location?.state?.daChange.aptelMSIDSN}</span>
                                      </div>
                                    </div>
                                    <div className="item">
                                      <div className="label">کد ملی:</div>
                                      <div className="value">
                                        <span dir="ltr">{location?.state?.purchase?.stR_CertNo}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="divider"></div>
                                <div className="holder-profile">
                                  <div className="list-item">
                                    <div className="item">
                                      <div className="label">شماره کیت جدید:</div>
                                      <div className="value">
                                        <span dir="ltr">{location?.state?.kitNo}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col span={10} xl={10} lg={10} md={24} sm={24} xs={24}>
                            <div className="for-pay-agent">
                              <h3>صورت حساب فروشنده</h3>
                              <div className="holder-box">
                                <div className="holder-list-pay">
                                  <ul>
                                    <li>
                                      <div className="label">هزینه سیم‌کارت</div>
                                      <div className="value">
                                        <span dir="ltr">{complexDigitToman(Math.abs(iccCommission || 0))}</span> <small>تومان</small>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="label">هزینه خدمات تحویل</div>
                                      <div className="value">
                                        <span dir="ltr">{complexDigitToman(Math.abs(Math.abs(commission || 0) - Math.abs(iccCommission || 0)))}</span>{" "}
                                        <small>تومان</small>
                                      </div>
                                    </li>
                                  </ul>
                                  <div className="hold-message success">
                                    <p>این مبلغ به کیف پول شما اضافه میگردد</p>
                                    <h3>
                                      <span dir="ltr">{complexDigitToman(Math.abs(commission || 0))}</span> تومان
                                    </h3>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="g-footer-format-page">
                  <div className="holder-button">
                    <Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmit}>
                      مرحله بعد
                    </Button>
                    <Button
                      className="btn-normal"
                      onClick={() => {
                        nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Kit);
                      }}
                      type="default"
                    >
                      بازگشت
                    </Button>
                  </div>
                </div>
              </div>
            </Content>
          </div>
        </div>
      </DALayout>
    </>
  );
};

export default DaPrefactor;
